/**
 * FAB (Floating Action Button) — 새 앨범 생성 트리거
 * - 모바일: bottom = 64px(BottomNav) + safe-area + 16px
 * - 데스크톱(md+): bottom-6 right-6
 * - /albums 경로에서만 표시
 * - isOpen: BottomSheet 오픈 상태에 따라 + 아이콘 45도 회전 (× 표시)
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

interface FABProps {
  onClick: () => void;
  isOpen?: boolean;
}

const FAB: React.FC<FABProps> = ({ onClick, isOpen = false }) => {
  const { t } = useTranslation();
  const location = useLocation();

  // /albums 정확 경로에서만 표시 (edit/export 제외)
  if (location.pathname !== '/albums') {
    return null;
  }

  return (
    <button
      onClick={onClick}
      aria-label={t('fab.newAlbum')}
      aria-expanded={isOpen}
      className={[
        'fixed z-[45] w-14 h-14 rounded-full',
        'bg-gradient-to-br from-blue-600 to-accent',
        'hover:from-blue-700 hover:to-accent-dark active:from-blue-800 active:to-accent-dark',
        'text-white shadow-lg hover:shadow-xl',
        'flex items-center justify-center',
        'transition-shadow duration-200',
        'focus:outline-none focus:ring-4 focus:ring-blue-300',
        // 모바일: BottomNav(64px) + safe-area + 16px 위
        'bottom-[calc(var(--bottom-nav-height,64px)+16px)] right-4',
        // 데스크톱: BottomNav 없으므로 낮춤
        'md:bottom-6 md:right-6',
      ].join(' ')}
    >
      <motion.div
        animate={{ rotate: isOpen ? 45 : 0 }}
        transition={{ duration: 0.2 }}
        className="motion-reduce:transition-none"
      >
        <Plus size={28} strokeWidth={2.5} />
      </motion.div>
    </button>
  );
};

export default FAB;
